export default __webpack_public_path__ + "static/media/3-6-3.d6987042.jpg";